import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { baseURL, getHeaders } from "./ServiceUtil";

export const whoAmI = (): Observable<{found: boolean, userGroupCount: number}> => {
  return ajax.getJSON<any>(`${baseURL}/whoami/whoami`, getHeaders());
};

